module.exports = __webpack_public_path__ + "static/media/hackersPainters.6c1124e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/finals/books/hackersPainters.jpg
// module id = 304
// module chunks = 0